import React, { useState, useEffect } from 'react';
import { Line } from '@ant-design/plots';

const ReachStatsComponent = ({ reachStats=[] }) => {
  const config = {
    data: reachStats,
    padding: 'auto',
    autoFit: true,
    xField: 'date',
    yField: 'value',
    xAxis: {
      // type: 'timeCat',
      tickCount: 5,
    },
    smooth: true,
  };

  return (
    <div>
      <h6>
        <strong>Reach</strong>
      </h6>
      <div className="d-flex p-2"
        style={{ height: 250 }}>
        <Line {...config}
          style={{ width: '100%' }} />
      </div>
    </div>
  );
};

export default ReachStatsComponent;
